module.exports = __webpack_public_path__ + "static/media/blurred-image-1.0e3525dc.jpg";